
import React from 'react';
import { cn } from '@/lib/utils';

interface LoadingSpinnerProps {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  variant?: 'default' | 'primary' | 'secondary' | 'accent';
  label?: string;
  center?: boolean;
}

export function LoadingSpinner({ 
  size = 'md', 
  variant = 'default',
  className,
  label = 'Loading',
  center = false
}: LoadingSpinnerProps) {
  const sizeClasses = {
    xs: 'h-3 w-3',
    sm: 'h-4 w-4',
    md: 'h-6 w-6',
    lg: 'h-8 w-8',
    xl: 'h-12 w-12',
  };
  
  const variantClasses = {
    default: 'border-gray-300 border-b-gray-600',
    primary: 'border-blue-100 border-b-blue-600',
    secondary: 'border-purple-100 border-b-purple-600',
    accent: 'border-brand-100 border-b-brand-600',
  };

  const spinner = (
    <div 
      className={cn(
        "relative inline-flex items-center justify-center",
        center && "flex h-full w-full items-center justify-center",
        className
      )}
    >
      <div 
        className={cn(
          "animate-spin rounded-full border-2", 
          sizeClasses[size],
          variantClasses[variant]
        )}
        role="status"
        aria-label={label}
      >
        <span className="sr-only">{label}</span>
      </div>
    </div>
  );
  
  if (center) {
    return (
      <div className="flex h-full w-full items-center justify-center min-h-[100px]">
        {spinner}
      </div>
    );
  }
  
  return spinner;
}
